/* App-wide providers: data, direction (Radix), tooltips and toasts. */
import { QueryClientProvider } from '@tanstack/react-query'
import { Direction } from 'radix-ui'
import type { ReactNode } from 'react'
import { Toaster, TooltipProvider } from '@/components/ui'
import { useLocale } from '@/i18n/useLocale'
import { queryClient } from './queryClient'

export function Providers({ children }: { children: ReactNode }) {
  const { dir } = useLocale()
  return (
    <QueryClientProvider client={queryClient}>
      <Direction.Provider dir={dir}>
        <TooltipProvider delayDuration={300} skipDelayDuration={200}>
          {children}
          <Toaster />
        </TooltipProvider>
      </Direction.Provider>
    </QueryClientProvider>
  )
}
